/**
 * Prevent a rapid second press from issuing a competing clinical write before
 * the first answer has durable device ownership. The latch is per logical UI
 * control, surfaces rejection through the caller, releases after acceptance
 * settles, and never logs or stores a body.
 */
export function startClinicalWriteAcceptance({
  activeKeys,
  key,
  accept,
  onRejected,
  onSettled,
}: {
  activeKeys: Set<string>;
  key: string;
  accept: () => Promise<void>;
  onRejected: () => void;
  onSettled: () => void;
}): boolean {
  if (activeKeys.has(key)) return false;
  activeKeys.add(key);
  void Promise.resolve()
    .then(accept)
    .catch(onRejected)
    .finally(() => {
      activeKeys.delete(key);
      onSettled();
    });
  return true;
}
